import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-farerulesmaster",
  templateUrl: "./farerulesmaster.component.html"
})
export class FarerulesmasterComponent implements OnInit {
  viewTitle: string = "Fare Product Rules Master";
  insertDataTitle: string = "Fare Product Rules Master";
  minRemark = false;
  loader: any = false;
  searchlist: boolean = true;
  showList: boolean = false;
  nameExist: boolean = false;
  aprvbtn = false;
  isApproved = false;
  approveStatus;
  updateApprove = false;
  searchresult = false;
  offSubmit = false;
  refundableMinLength = false;
  refundableExceedLength = false;
  nonRefundableMinLength = false;
  nonRefundableExceedLength = false;
  screentitle: string = "Fare Product Rules Master";
  actionmode: string = "Seacrh";
  parent_table = "UB_MST_FARE_RULES";

  FARE_PRODUCT_LABEL = "FARE_PRODUCT_LABEL";
  REFUNDABLE_FARE_RULE = "REFUNDABLE_FARE_RULE";
  NONREFUNDABLE_FARE_RULE = "NONREFUNDABLE_FARE_RULE";

  childtables = ["cnf_fare_product"];
  childtabless = [];
  childtables1 = "cnf_fare_product";
  filters = ["FARE_PRODUCT_ID"];
  filterss = [];
  parent_table_ID = "FARE_RULES_ID";
  Parent_result_ID = "";
  search_details: any = [];

  p: number = 1;

  fareProductLabels: any = [
    { key: "ECOFP1", value: "Economy" },
    { key: "ECOFP2", value: "Economy Plus" },
    { key: "ECOFP3", value: "Economy Pro" },
    { key: "BUSFP1", value: "Premium" }
  ];

  searchFareProductLabels: any = [
    { key: "ECOFP1", value: "Economy" },
    { key: "ECOFP2", value: "Economy Plus" },
    { key: "ECOFP3", value: "Economy Pro" },
    { key: "BUSFP1", value: "Premium" }
  ];

  dbFields = [
    this.FARE_PRODUCT_LABEL,
    this.REFUNDABLE_FARE_RULE,
    this.NONREFUNDABLE_FARE_RULE
  ];
  dbFieldss = [
    this.FARE_PRODUCT_LABEL,
    this.REFUNDABLE_FARE_RULE,
    this.NONREFUNDABLE_FARE_RULE,
    "STATUS"
  ];

  searchitem = " ";
  searchColumn = " ";
  screen_details: any = [];
  serachtabledata: any = [];
  serachTableInfo: any = [];
  data: any = [];
  status: any = {};
  combo_details1: any = [];
  combo_details2: any = [];
  sortType = "";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  // count1 = 0;
  // count2 = 0;
  // count3 = 0;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  constructor(
    private vernostService: VernostServiceService,
    private commonService : CommonService
    ) {}

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");

    var rollArrayFareRuleMaster = {
      funId: this.fid,
      roleID: this.roleID
    };

    this.vernostService.checkFunAccess(rollArrayFareRuleMaster).subscribe(res => {
      this.RAC_VIEW = JSON.stringify(res[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(res[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(res[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(res[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      FARE_PRODUCT_LABEL: "",
      REFUNDABLE_FARE_RULE: "",
      NONREFUNDABLE_FARE_RULE: ""
    };
    this.addCombo(this.childtables[0]);

    this.search_details = {
      FARE_PRODUCT_LABEL: ""
    };
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };
    this.showList = false;
  }

  addForm() {
    document.getElementById("errs").innerHTML = "";
    this.screen_details = {
      FARE_PRODUCT_LABEL: "",
      REFUNDABLE_FARE_RULE: "",
      NONREFUNDABLE_FARE_RULE: ""
    };
    this.refundableMinLength = false;
    this.refundableExceedLength = false;
    this.nonRefundableMinLength = false;
    this.nonRefundableExceedLength = false;
    this.Parent_result_ID = "";
    this.actionmode = "Add";
    this.showList = false;
    this.nameExist = false;
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };
  }

  searchForm() {
    document.getElementById("errs").innerHTML = "";
    this.screen_details = {
      FARE_PRODUCT_LABEL: "",
      REFUNDABLE_FARE_RULE: "",
      NONREFUNDABLE_FARE_RULE: ""
    };
    this.actionmode = "Search";
    this.aprovebtn = true;
    this.rejectbtn = true;
    // this.searchData();
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    let arrayFareRuleMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayFareRuleMaster).subscribe(res => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(res[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  getremark(val) {
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }

  clearRemark() {
    this.aprove_details.APPROVAL_REMARKS = "";
  }

  changeName() {
    // alert(this.Parent_result_ID);
    let dataFareRuleMaster = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "FARE_RULES_ID"
    };

    this.vernostService.getSTATUS(dataFareRuleMaster).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    if (this.actionmode == "Edit") {
      var data = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(data).subscribe(response => {
        //   alert(response);
        this.isApproved = false;
      });
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

/*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var dataFareRuleMaster = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "FARE_RULES_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataFareRuleMaster).subscribe(response => {
      this.searchData();
    });
  } */

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'fare-rules-master');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();

    var dbFieldFareRuleMaster = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataFareRuleMaster = [
      status,
      this.aprove_details.APPROVAL_REMARKS,
      this.uid,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldFareRuleMaster,
      parent_table: this.parent_table,
      formData: formDataFareRuleMaster,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };

    this.vernostService.aproveReject(array).subscribe(res => {
      this.aprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        this.searchForm();
        this.searchData();
      } else {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
        this.aprvbtn = false;
        /* if (res[0].aproval == "aproved") {
          this.aprvbtn = false;
          // this.aprovebtn=false;
          //  alert(JSON.stringify(res[0].status));
          //  this.searchForm();
        }
        if (res[0].aproval == "rejected") {
          this.aprvbtn = false;
          // this.aprovebtn=false;
          //  alert(JSON.stringify(res[0].status));
          //this.searchForm();
        } else {
          this.aprvbtn = false;
          // alert("in else");
          // this.rejectbtn=false;
          // alert(JSON.stringify(res[0].status));
          // this.searchForm();
        } */
      }
      if (this.actionmode == "Edit") {
        this.submitData1();
      }
      this.searchData();
    });
  }
  setId(id) {
    this.Parent_result_ID = id;
  }
  checkEdit() {
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      this.RAC_APROVE = "1";
    }
  }

/*
  sortByOrder(data, number_farerule) {
    if (number_farerule == 1) {
      if (this.count1 % 2 == 0) {this.sortType = "ASC";} 
      else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
      this.count3 = 0;
    }
    if (number_farerule == 2) {
      if (this.count2 % 2 == 0) { this.sortType = "ASC"; } 
      else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
      this.count3 = 0;
    }
    if (number_farerule == 3) {
      if (this.count3 % 2 == 0) { this.sortType = "ASC";  } 
      else {
        this.sortType = "DESC";
      }
      this.count3++;
      this.count1 = 0;
      this.count2 = 0;
    }
    var arrayFareRuleMaster = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayFareRuleMaster).subscribe(res => {
      this.serachtabledata = res;
    });
  }
  */

  addCombo(childtable) {
    var array = {
      childtable: childtable
    };
    this.vernostService.getComboData(array).subscribe(response => {
      if (response[0].status == this.childtables[0]) {
        this.combo_details1 = response[0].result;
      }
      if (response[0].status == this.childtables[1]) {
        this.combo_details2 = response[0].result;
      }
    });
  }

  // onSelectedId() {
  //   this.nameExist = false;
  //   this.gotochangestatus();
  //
  //   var id = this.screen_details.FARE_PRODUCT_ID;
  //
  //   var array = {
  //     childtable: this.childtables1
  //   };
  //   this.vernostService.getComboData(array).subscribe(response => {
  //     if (response[0].status == this.childtables[0]) {
  //       this.combo_details1 = response[0].result;
  //       for (var i = 0; i < response.length; i++) {
  //         for (var j = 0; j < response[i].result.length; j++) {
  //           if (response[i].result[j].FARE_PRODUCT_ID == id) {
  //             console.log("succcccccccccc");
  //             this.screen_details.FARE_PRODUCT_LABEL =
  //               response[i].result[j].FARE_PRODUCT_LABEL;
  //             // break;
  //           }
  //         }
  //       }
  //     }
  //   });
  // }

  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }
    this.Parent_result_ID = formData;

    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFieldss,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(array).subscribe(response => {
      this.screen_details = {
        FARE_PRODUCT_LABEL: response[0].result[0].FARE_PRODUCT_LABEL,
        REFUNDABLE_FARE_RULE: response[0].result[0].REFUNDABLE_FARE_RULE,
        NONREFUNDABLE_FARE_RULE: response[0].result[0].NONREFUNDABLE_FARE_RULE
      };
      this.approveStatus = response[0].result[0].STATUS;
      this.serachTableInfo = response[0].result;

      if (toggle == "1") {
        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitdata() {
    this.offSubmit = false;
    var formData = [
      this.screen_details.FARE_PRODUCT_LABEL,
      this.screen_details.REFUNDABLE_FARE_RULE,
      this.screen_details.NONREFUNDABLE_FARE_RULE
    ];

    var fareProductLabel = this.screen_details.FARE_PRODUCT_LABEL;
    var refundable = this.screen_details.REFUNDABLE_FARE_RULE;
    var nonRefundable = this.screen_details.NONREFUNDABLE_FARE_RULE;
    if (fareProductLabel == "" || refundable == "" || nonRefundable == "") {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      if (this.Parent_result_ID == "") {
        document.getElementById("errs").innerHTML = "";
        if (this.Parent_result_ID == "") {
          var Data = {
            parent_table: this.parent_table,
            dbFields: this.dbFields,
            formData: formData,
            USER_ID: this.uid,
            PAGENAME: "RULE"
          };
          this.vernostService.insertData(Data).subscribe(response => {
            document.getElementById("errs").innerHTML =
              "Record Successfully Created";

            if (JSON.stringify(response[0].message == "Data inserted")) {
              this.showFormData(response[0].addinfo, 3, 1, 1);
            }
          });
        }
      }

      if (this.Parent_result_ID != "") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editData(array).subscribe(response => {
          // alert(JSON.stringify(response[0].status));
          this.searchForm();
        });
      }
    }
  }

  // fareProducts: any = ["ECOFP1", "ECOFP2", "ECOFP3"];
  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.FARE_PRODUCT_LABEL;

    if (field1 == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "") {
        searchitem.push(field1);
        searchColumn.push("FARE_PRODUCT_LABEL");
      }

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtabless,
        filters: this.filterss
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchRecord(Data).subscribe(response => {
        if (response.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;

          this.searchresult = true;
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record not found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  checkRefundable(data) {
    this.validateRefundable(data);
  }
  validateRefundable(data) {
    if (data.length == 0) {
      this.refundableMinLength = false;
    } else {
      if (data.length < 10) {
        this.refundableMinLength = true;
      } else {
        this.refundableMinLength = false;
      }
    }
  }
  checkRefundableLength(data) {
    this.refundableExceedLength = false;
    this.refundableMinLength = false;

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      this.RAC_APROVE = "1";
    }

    if (data.length > 500) {
      this.refundableExceedLength = true;
      this.refundableMinLength = false;
    } else {
      this.refundableExceedLength = false;
    }
  }

  checkNonRefundable(data) {
    this.validateNonRefundable(data);
  }
  validateNonRefundable(data) {
    if (data.length == 0) {
      this.nonRefundableMinLength = false;
    } else {
      if (data.length < 10) {
        this.nonRefundableMinLength = true;
      } else {
        this.nonRefundableMinLength = false;
      }
    }
  }
  checkNonRefundableLength(data) {
    this.nonRefundableExceedLength = false;
    this.nonRefundableMinLength = false;

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      this.RAC_APROVE = "1";
    }

    if (data.length > 500) {
      this.nonRefundableExceedLength = true;
      this.nonRefundableMinLength = false;
    } else {
      this.nonRefundableExceedLength = false;
    }
  }

  submitData1() {
    ///  this.loader = true;
    var fareProductLabel = this.screen_details.FARE_PRODUCT_LABEL;
    var refundable = this.screen_details.REFUNDABLE_FARE_RULE;
    var nonRefundable = this.screen_details.NONREFUNDABLE_FARE_RULE;
    if (fareProductLabel == "" || refundable == "" || nonRefundable == "") {
      document.getElementById("errs").innerHTML = "Please  fill all data";
    } else {
      if (this.actionmode != "Edit") {
        this.offSubmit = true;
        this.checkNames();
      } else {
        this.submitdata();
      }
    }
  }
  checkNames() {
    if (
      this.screen_details.FARE_PRODUCT_LABEL != "" &&
      this.screen_details.FARE_PRODUCT_LABEL != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "FARE_PRODUCT_LABEL",
          dbFieldName: this.screen_details.FARE_PRODUCT_LABEL,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist = true;
          }
        });
      }
    }
  }

  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }
}
